import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { setSepsisIndicatorsOptions } from '../store/options.actions'
import { OptionsService } from '../services/options.service'

export function* getSepsisIndicatorsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getSepsisIndicatorsOptions])
    const { entity } = response

    yield put(setSepsisIndicatorsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getSepsisIndicatorsOptions() error: ${e}`))
  }
}

export function* getSepsisIndicatorsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getSepsisIndicatorsOptions)
}
